/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type GroomingTypeEnum = (typeof GroomingTypeEnum)[keyof typeof GroomingTypeEnum];

export const GroomingTypeEnum = {
  bath_and_brush: 'bath_and_brush',
  full_groom: 'full_groom',
} as const;
